import QuillWysiwyg from './QuillWysiwyg';

export default QuillWysiwyg;
